import type {
    GetDepartmentsResponseType,
    GetDepartmentsRequestType
} from "./type";
import {
    request
} from "../request";

const getDepartments = async (
    params: GetDepartmentsRequestType
): Promise<GetDepartmentsResponseType> => {
    return await request<GetDepartmentsResponseType>(`/staticData/getDepartments?facultyID=${params.facultyID}`, {
        method: "GET"
    });
};

export default getDepartments;
